import moment from 'moment/moment'
import { divideInNIntegers } from '../../../common/mathHelper'
import { xlCol, xlColq } from '../../../common/constants'
import { backGroundColor, buildCompositeFields } from '../../../common/helper'
import { STA_COMPANY_ID } from '../../../../helper/companyIdhardcode'

export const reportOptionSum = [
  { Option: 'All', optionId: 0 },
  { Option: 'Payment Type Wise', optionId: 1 },
  { Option: 'Source City Wise', optionId: 2 },
  { Option: 'Source Branch Wise', optionId: 3 },
  { Option: 'Destination City Wise', optionId: 4 },
  { Option: 'Destination Branch Wise', optionId: 5 },
  { Option: 'Booking Date Wise', optionId: 6 },
]
export const reportOptionDet = [{ Option: 'LR Details with Status', optionId: 0 }]
export const reportViewData = [
  { view: 'Detailed', id: 0 },
  { view: 'Summary', id: 1 },
]
export const paymentWiseColumns = [
  { headerName: 'Serial Number', field: 'SN', xlCol, align: 'left' },
  { headerName: 'Payment Type', field: 'PaymentType', xlCol, align: 'left', isSortIcon: true },
  { headerName: 'LR Count', field: 'LRCount', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Units', field: 'Units', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Freight', field: 'Freight', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Document Charge', field: 'DocumentCharges', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Cartage', field: 'Cartage', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Hamali ', field: 'Hamali', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Operator Hamali', field: 'OperatorHamali', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Valuation Charge', field: 'Valuation', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Other Charge', field: 'OtherCharge', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Booking GST', field: 'ServiceTax', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Net Amount', field: 'TotalAmount', xlCol: xlColq, align: 'right', isSortIcon: true },
]
export const SNCol = {
  headerName: 'Serial Number',
  exportHead: 'S/N',
  field: 'SN',
  xlCol: xlCol,
  align: 'left',
}
export const sourceCityCol = {
  headerName: 'Source City ',
  exportHead: 'Source City ',
  field: 'BookingCity',
  xlCol: { dataType: 'string', dataFormatter: null, halign: 'left' },
  align: 'left',
  isSortIcon: true
}
export const sourceBranchCol = {
  headerName: 'Source Branch',
  exportHead: 'Source Branch',
  field: 'BookingBranch',
  xlCol: xlCol,
  align: 'left',
  isSortIcon: true
}
export const destCityCol = {
  headerName: 'Destination City',
  exportHead: 'Dest City',
  field: 'DestinationCity',
  xlCol: xlCol,
  align: 'left',
  isSortIcon: true
}
export const destBranchCol = {
  headerName: 'Destination Branch',
  exportHead: 'Dest Branch',
  field: 'DestinationBranch',
  xlCol: xlCol,
  align: 'left',
  isSortIcon: true
}
export const headerColumns = [
  { headerName: 'Paid', exportHead: 'Paid', field: 'TotalPaid', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Paid Manual', exportHead: 'Paid Man.', field: 'TotalPaidMan', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'ToPay', exportHead: 'ToPay', field: 'TotalToPay', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'ToPay Manual', exportHead: 'ToPay Man.', field: 'TotalToPayMan', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'ToPay DDDV', exportHead: 'ToPay DDDV', field: 'TotalToPayDDDV', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'On Account', exportHead: 'On Acc.', field: 'TotalOnAcc', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'On Acc Manual', exportHead: 'On Acc Man.', field: 'TotalOnAccMan', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Self Booking', exportHead: 'Self Bkg.', field: 'TotalSelf', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'COD', exportHead: 'COD', field: 'TotalCOD', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'FOC', exportHead: 'FOC', field: 'TotalFoc', xlCol: xlColq, align: 'right', isSortIcon: true },
  { headerName: 'Total Amt', exportHead: 'Total Amt', field: 'GrandTotal', xlCol: xlColq, align: 'right', isSortIcon: true },
]
export const lrDetailsColumns = [
  { header: 'S/N', exportHead: 'Serial\nNumber', field: 'SN', xlCol: xlCol, align: 'center', width: '30px' },
  { header: 'LR Number\nManual LR Number', exportHead: 'LR Number\nManual LR Number', field: 'LRNO^^ManualLRNo', xlCol: xlCol, align: 'left', width: '60px', isSortIcon: true },
  { header: 'Formatted LR Number\nManual LR Number', exportHead: 'Formatted LR Number\nManual LR Number', field: 'FormattedLRNO^^ManualLRNo', xlCol: xlCol, align: 'left', width: '60px', isSortIcon: true },
  { header: 'Formatted\nLR Number', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', xlCol: xlCol, align: 'left', width: '60px', isSortIcon: true },
  { header: 'Booking Date\nBooking Time', exportHead: 'Booking Date\nBooking Time', field: 'BookingDate^^BookingTime', xlCol: xlCol, align: 'left', width: '75px', isSortIcon: true },
  { header: 'Source City\nSource Branch', exportHead: 'Source City\nSource Branch', field: 'SourceCity^^SourceBranch', xlCol: xlCol, align: 'left', width: '120px', isSortIcon: true },
  { header: 'Dstination City\nDstination Branch', exportHead: 'Destination City\nDestination Branch', field: 'DestinationCity^^DestinationBranch', xlCol: xlCol, align: 'left', width: '120px', isSortIcon: true },
  { header: 'Sender Name\nSender Contact', exportHead: 'Sender Name\nSender Contact', field: 'Sender^^SenderMobileNo', xlCol: xlCol, align: 'left', width: '80px', isSortIcon: true },
  { header: 'Receiver Name\nReceiver Number', exportHead: 'Receiver Name\nReceiver Number', field: 'RecName^^RecMobileNo', xlCol: xlCol, align: 'left', width: '80px', isSortIcon: true },
  { header: 'Payment\nType', exportHead: 'Payment Type', field: 'PaymentType', xlCol: xlCol, align: 'left', width: '40px', isSortIcon: true },
  { header: 'LR\nStatus', exportHead: 'LR Status', field: 'Status', xlCol: xlCol, align: 'left', width: '80px', isSortIcon: true },
  { header: 'Item\nUnits', exportHead: 'Item Units', field: 'Items', xlCol: xlColq, align: 'right', width: '30px', isSortIcon: true },
  { header: 'Net\nAmount', exportHead: 'Net Amount', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null, halign: 'right' }, align: 'right', width: '50px', isSortIcon: true },
]

export const lrDetailsDataFormat = (arr, headers, headerData) => {
  let index = 0
  const lengths = divideInNIntegers(headers.length, 3)
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })
  const array = arr
    .map((item, i) => {
      const bookingDateTime = moment(item?.BookingDate)
      const BookingDate = bookingDateTime.format('DD-MMM-YY')
      const BookingTime = bookingDateTime.format('hh:mm A')
      return {
        SN: i + 1,
        ...item,
        BookingDate,
        BookingTime,
        dataType: 'entry',
        StatusView: item.Status,
        // (
        //   <span className="status" style={{ backgroundColor: backGroundColor[`${item.Status}`] }}>
        //     {item.Status}
        //   </span>
        // ),
      }
    })
    .map((item) => ({ ...item, ...buildCompositeFields(item, lrDetailsColumns) }))

  const { Items, NetAmount } = arr.reduce(
    (acc, item) => {
      acc.Items += +item.Items
      acc.NetAmount += +item.NetAmount
      return acc
    },
    { Items: 0, NetAmount: 0 }
  )
  array.push({
    [pickedHeaders[0]]: `Total Amount`,
    colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'Items') },
    align: { [pickedHeaders[0]]: 'right' },
    Items: Items,
    NetAmount: NetAmount.toFixed(2),
    dataType: 'total',
  })
  array.unshift({
    [pickedHeaders[0]]: `Source City:${headerData?.selSourceCity}`,
    [pickedHeaders[1]]: `Destination City: ${headerData?.selDestinationCity}`,
    [pickedHeaders[2]]: `Payment Type: ${headerData?.paymentType}`,
    colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
    dataType: 'subHeader',
  })

  return array
}

export const excelHeader = [
  { field: 'fromDate', header: 'From Booking Date', xlCol },
  { field: 'toDate', header: 'To Booking Date', xlCol },
  { field: 'selSourceCity', header: 'Source City', xlCol },
  { field: 'selSourceBranch', header: 'Source Branch', xlCol },
  { field: 'selDestinationCity', header: 'Destination City', xlCol },
  { field: 'selDestinationBranch', header: 'Destination Branch', xlCol },
  { field: 'paymentType', header: 'Payment Type', xlCol },
  { field: 'reportView', header: 'Report View', xlCol },
  { field: 'reportOptions', header: 'Report Options', xlCol: xlColq },
]

export const addTotal = (array, headerData, heading, headers, companyID) => {
  if (!Array.isArray(array) || array.length === 0) return array
  const lengths = divideInNIntegers(headers.length, 3)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })
  let fields = [
    'TotalPaid',
    'TotalPaidMan',
    'TotalToPay',
    'TotalToPayMan',
    'TotalToPayDDDV',
    'TotalOnAcc',
    'TotalOnAccMan',
    'TotalSelf',
    'TotalCOD',
    'TotalFoc',
    'GrandTotal',
  ]
  if ([STA_COMPANY_ID].includes(companyID)) {
    fields = [
      ...fields,
      'DocumentCharges',
      'Cartage',
      'Valuation',
    ]
  }
  const totals = fields.reduce((acc, field) => {
    acc[field] = 0
    return acc
  }, {})

  for (const item of array) {
    for (const field of fields) {
      totals[field] += Number(item?.[field] || 0)
    }
  }

  for (const field of fields) {
    totals[field] = totals[field].toFixed(2)
  }
  array.push({
    SN: heading,
    ...totals,
    dataType: 'total',
    colSpan: {
      SN: headers.length - fields.length,
    },
  })
  const subHeader = {
    dataType: 'subHeader',
    colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    ...Object.fromEntries([
      [pickedHeaders[0], `Source City: ${headerData?.selSourceCity || ''}`],
      [pickedHeaders[1], `Destination City: ${headerData?.selDestinationCity || ''}`],
      [pickedHeaders[2], `Payment Type: ${headerData?.paymentType || ''}`],
    ]),
  }
  array.unshift(subHeader)
  return array
}

export const paymentWiseAddTotal = (array, headerData, heading, headers) => {
  const lengths = divideInNIntegers(headers.length, 3)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })

  const fieldsToSum = [
    'LRCount',
    'Units',
    'Freight',
    'DocumentCharges',
    'Cartage',
    'Hamali',
    'OperatorHamali',
    'Valuation',
    'OtherCharge',
    'TotalAmount',
  ]
  if (headers.find((item) => item.field === 'ServiceTax')) {
    fieldsToSum.push('ServiceTax')
  }

  const totals = array.reduce((sumObj, row) => {
    fieldsToSum.forEach((field) => {
      sumObj[field] = (sumObj[field] || 0) + Number(row[field] || 0)
    })
    return sumObj
  }, {})

  const totalRow = {
    SN: heading,
    ...Object.fromEntries(Object.entries(totals).map(([field, value]) => [field, value.toFixed(2)])),
    dataType: 'total',
    colSpan: {
      SN: headers.length - fieldsToSum.length,
    },
  }

  const subHeader = {
    dataType: 'subHeader',
    colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    ...Object.fromEntries([
      [pickedHeaders[0], `Source City: ${headerData?.selSourceCity}`],
      [pickedHeaders[1], `Destination City: ${headerData?.selDestinationCity}`],
      [pickedHeaders[2], `Payment Type: ${headerData?.paymentType}`],
    ]),
  }

  return [subHeader, ...array, totalRow]
}

export const groupData = (key, array, headerData, headers) => {
  const lengths = divideInNIntegers(headers.length, 4)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })

  const grouped = array.reduce((acc, item) => {
    if (item.dataType === 'total' || item.dataType === 'subHeader') return acc
      ; (acc[item[key]] ??= []).push(item)
    return acc
  }, {})

  const fieldsToSum = [
    'LRCount',
    'Units',
    'Freight',
    'DocumentCharges',
    'Cartage',
    'Hamali',
    'OperatorHamali',
    'Valuation',
    'OtherCharge',
    'TotalAmount',
  ]
  if (headers.find((item) => item.field === 'ServiceTax')) {
    fieldsToSum.push('ServiceTax')
  }

  const updatedData = Object.entries(grouped).flatMap(([groupKey, items]) => {
    const formattedDate = moment(groupKey).format('DD-MMM-YYYY')

    items.forEach((item, i) => (item.SN = i + 1))
    const totals = fieldsToSum.reduce((sumObj, field) => {
      sumObj[field] = items.reduce((total, row) => total + Number(row[field] || 0), 0)
      return sumObj
    }, {})

    const subHeader = {
      dataType: 'subHeader',
      colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
      ...Object.fromEntries([
        [pickedHeaders[0], `Booking Date: ${formattedDate}`],
        [pickedHeaders[1], `Source City: ${headerData?.selSourceCity}`],
        [pickedHeaders[2], `Destination City: ${headerData?.selDestinationCity}`],
        [pickedHeaders[3], `Payment Type: ${headerData?.paymentType}`],
      ]),
    }
    const totalRow = {
      SN: `Total Amount: ${formattedDate}`,
      ...Object.fromEntries(Object.entries(totals).map(([field, value]) => [field, value.toFixed(2)])),
      dataType: 'total',
      colSpan: { SN: 2 },
    }

    return [subHeader, ...items, totalRow]
  })
  const grandTotals = fieldsToSum.reduce((sumObj, field) => {
    sumObj[field] = updatedData.filter((row) => row.dataType === 'total').reduce((total, row) => total + Number(row[field] || 0), 0)
    return sumObj
  }, {})

  const grandTotalRow = {
    SN: 'Gross Amount: Selected Dates',
    ...Object.fromEntries(Object.entries(grandTotals).map(([field, value]) => [field, value.toFixed(2)])),
    dataType: 'total',
    colSpan: { SN: 2 },
  }

  updatedData.push(grandTotalRow)
  return updatedData
}

export const userWiseExcelHeader = [
  { col: 1, value: 'From Collection Date' },
  { col: 1, value: 'To Collection Date' },
  { col: 2, value: 'Select Company Branch' },
  { col: 2, value: 'Company User' },
  { col: 2, value: 'Transaction Type' },
  { col: 1, value: 'Payment Type' },
  { col: 1, value: 'Payment Mode' },
  { col: 1, value: 'Report View' },
]
export const userWiseExcelDetailHeader = [
  { col: 2, value: 'From Collection Date' },
  { col: 1, value: 'To Collection Date' },
  { col: 2, value: 'Select Company Branch' },
  { col: 2, value: 'Company User' },
  { col: 2, value: 'Transaction Type' },
  { col: 1, value: 'Payment Type' },
  { col: 1, value: 'Payment Mode' },
  { col: 1, value: 'Report View' },
]
